// import jsbridge from '@kkmh/jsbridge';
import {
    ua,
    qs,
    debug as loging,
    getDeepVal,
} from '@kkmh/utils'
//hybrid方法
const hybrid = (options) => {
    /**
     * @window.hybrid方法 参数说明
     * @param {Object} jsBridgeParams.hybridParam : jsBridge调用参数
     * @param {Object} jsBridgeParams.param : 参数
     * @param {Function} jsBridgeParams.callback : 回调
     * @param {Boolean} jsBridgeParams.on : 是否保留回调
     * @param {String} hybridParam.schema : 协议名称
     * @param {String} hybridParam.tagname : 方法名称
    */
    var jsBridgeParams = {
        hybridParam : {
            schema      : options.schema,    //string : kkmhhybrid, kkhybrid, kkaction ...
            tagname     : options.tagname,    //string : 方法名称    
        },
        param       : options.param,
        on          : options.is_del_nativecallback === false || false,
        callback    : function(res, cbnm){    //string : native调用js回调函数
            if (typeof res == 'string') res = JSON.parse(res);
            // loging(`[${tagname}返回]`,JSON.parse(JSON.stringify(res)));
            options.callback && options.callback(res,cbnm)
        },
    }

    // ******* 判断浏览器环境，kuaikan-chrome是模拟器 *******
    if (!/kuaikan\//.test(navigator.userAgent.toLowerCase()) || /kuaikan-chrome/.test(navigator.userAgent.toLowerCase())) {
        var res = {};
        typeof callback === "function" && callback(res);
    } else {
        // jsbridge(obj);
        window.hybrid(jsBridgeParams);
    }
}

var subscribeListenerOnViewBack = function(){};
var recivefreecardinfo = function(){};
var getLoginStatus = function(){};
var request_record      = {};
var current_login_mode  = '';
var is_first_init       = false; // 是否执行过一次
var count_num           = 0;
var time_record         = {};
let {appVersion, criticalAppVersion} = window.kkBaseInfo;
window.__gvalkkmh       = {
    is_called_handshake : appVersion >= criticalAppVersion,
    is_called_loginwindow : false,
    is_track_identified : false,
    ua,
    param : qs,
    user : {},
    sys : {},
}

const LOGIN_UNWANTED        = 'unwanted'; //不需登录
const LOGIN_NEED            = 'need';     //需要弹窗登录 （判断是否已登录）
const LOGIN_MUST            = 'must';     //强制弹窗登录（不判断是否已登录，处理401/402等接口code）
const IS_SYSINFO_VER        = ua.appversion >= criticalAppVersion; // 新协议迁移时要get_user里加性别，版本未定
const IS_POPLOGIN_VER       = ua.appversion >= criticalAppVersion; // 较稳定登录版本
const IS_WKUSEAJAX_LOWVER   = (window.__gvalkkmh.ua.wkwebview && ua.appversion <= 572000) || false; // wkwebview登录框消失后接口请求偶现失败，572000修复
const KKMHHYBRID            = 'kkmhhybrid';
const KKHYBRID              = 'kkhybrid';
const KKACTION              = 'kkaction';
const KKHYBRIDAPI           = 'kkhybridapi';
const TAGNAMES              = {
    //kkmhhybrid
    'handshake'         : {schema : KKMHHYBRID},
    'get_sys'           : {schema : KKMHHYBRID},
    'get_user'          : {schema : KKMHHYBRID},
    'get_freecard'      : {schema : KKMHHYBRID},
    'logout_new'        : {schema : KKMHHYBRID},
    'login'             : {schema : KKMHHYBRID, is_del_nativecallback : false},
    //kkaction
    'getSysDeviceInfo'  : {schema : KKACTION},
    //kkhybridapi
    'scroll_whitearea'   : {
        schema : KKMHHYBRID,
        param  : {
            conf2scrollwhitearea : 1,//去掉白边
        }
    },
    //kkhybrid
    'login_result'      : {schema : KKHYBRID},
    'logout'            : {schema : KKHYBRID},
    'login_win'         : {schema : KKHYBRID},
    'header'            : {
        schema  : KKHYBRID,
        param   : {
            config      : 'screen',
            display     : 1, //默认是1：竖屏，2：横屏
            fullScreen  : 'show', //show是全屏幕,hide是显示topbar
            data        : {}
        }
    },
}
/**
 * res 3种结果
 * 1. {device_id:''}
 * 2. { errno=0, data={}, msg='' }
 * 3. { code=200, data={}, message='ok' }
 * **/

const formatRes = (res, tagname) => {
    let { code, errno, data, message, msg } = res;
    if (tagname == 'getSysDeviceInfo') {
        data = res;
    }
    return {
        code : code || errno || 0,
        message : message || msg || '',
        data : data || {},
    }
}
const request = (tagname) => {
    return new Promise(resolve => {
        let item = TAGNAMES[tagname];
        if (!item) {
            resolve(formatRes({message:`${tagname}-未定义的协议名称`}));
        }

        if (tagname == 'logout_new') tagname = 'logout';//与老协议名冲突

        let options = {
            tagname : tagname, 
            schema  : item.schema,
            param   : item.param || {},
            is_del_nativecallback : item.is_del_nativecallback==false ? false : true,
        }

        setRequestRecord(tagname, options);

        hybrid({ 
            tagname : options.tagname, 
            schema  : options.schema,
            param   : options.param,
            is_del_nativecallback   : options.is_del_nativecallback,
            callback : (res) => {
                setResponseRecord(tagname, res);

                if (!/kuaikan\//.test(navigator.userAgent.toLowerCase()) || /kuaikan-chrome/.test(navigator.userAgent.toLowerCase())) {
                    resolve(formatRes(res, tagname));
                }
                if (tagname == 'login') {
                    // path_step 0->打开登录窗体 1->关闭登录窗口
                    if (getDeepVal(res,'data.path_step',0) == 1) {
                        // is_success_login 0-> 没有登录 1->登录成功
                        resolve(formatRes(res, tagname));
                    }
                } else {
                    resolve(formatRes(res, tagname));    
                }
            }
        })
    });
}
const setRequestRecord = (tagname, options) => {
    time_record[`request-${tagname}`] = new Date().getTime();

    let key = `${PrefixZero(count_num++)}.request-${tagname}`;
    request_record[key] = options;
}
const setResponseRecord = (tagname, res) => {
    let t = new Date().getTime() - time_record[`request-${tagname}`];

    let key = `${PrefixZero(count_num++)}.response-${tagname}-耗时${t}ms`;
    request_record[key] = res;
}
function PrefixZero(num) {
    return (Array(2).join(0) + num).slice(-2);
}

//设置cookie - 本地ip可调试 && 也能解决线上ios-wkwebview问题（之前登录后请求未能同步至h5域名cookie，572000 版本修复）
const setUserSession = () => {
    if (window.__gvalkkmh.user.session) {
        window.__gvalkkmh.user.session.split(";").forEach((item) => {
            var domain = '';//获取一级域名(domain=.kuaikanmanhua.com;)
            if(/\.com|\.cn/.test(location.hostname)) {
                 domain = 'domain=.'+location.hostname.split('.').slice(-2).join('.')+';';
            }
            var Days = 15;
            var exp = new Date();
            exp.setTime(exp.getTime() + Days*24*60*60*1000);
            var cookie = item + ";"+ domain +"path=/;expires=" + exp.toGMTString()+"";
            document.cookie = cookie;
        });
    }
}

//去掉客户端白
const setIosWhiteArea = () => {
    if(
        window.__gvalkkmh.ua.iphone && 
        !/conf2scrollwhitearea/.test(location.href) && 
        !is_first_init
    ) {
        request('scroll_whitearea');
    } 
}
//设置竖全屏
const setFullScreen = () => {
    if (/conf2fullscreen=1/.test(location.href) && window.__gvalkkmh.ua.local && !is_first_init) {
        request('header');
    }
}

//初始化埋点信息
const setTrack = () => {
    let uid = window.__gvalkkmh.user.id;
    let did = window.__gvalkkmh.sys.device_id;
    if (typeof kksa != "undefined") {
        let track_id = uid ? uid.toString() : did;
        if (track_id) {
            kksa.identify(track_id);
            kksa.is_identified = true;
            window.__gvalkkmh.is_track_identified = true;
        }

        if (/kksa_identify=true/.test(location.href)) {
            kksa.is_identified = true;
            window.__gvalkkmh.is_track_identified = true;
        }
    }
}

const sysinfo = (mode) => {
    return new Promise(resolve => {
        if (IS_SYSINFO_VER) {
            getSysNew(mode).then(() => {
                resolve();
            });
        } else {
            getSysOld(mode).then(() => {
                resolve();
            });
        }
    });
}
const getSysNew = (mode) => {
    return new Promise(resolve => {
        if (mode == 'update_user') {
            request('get_user').then((res_user) => {
                let data_user = res_user.data || {};
                data_user.uid = data_user.id || 0;
                setUser(data_user)
                resolve();
            });
        } else {
            window.getBaseInfoPromise.then((res) => {
                setBaseInfo(res);
                resolve();
            });
        }
    });
}
const getSysOld = (mode) => {
    return new Promise(resolve => {
        if (mode == 'update_user') {
            request('login_result').then((res_user) => {
                let data_user = res_user.data || {}
                setUser(data_user)
                resolve();
            });
        } else {
            window.getBaseInfoPromise.then((res) => {
                setBaseInfo(res);
                resolve();
            });
        }
    });
}
const setBaseInfo = (res) => {
    window.__gvalkkmh.getBaseInfoPromiseData = res;
    let {sys, user} = res;
    setSys(sys);
    setUser(user)
} 
const setSys = (sys) => {
    window.__gvalkkmh.sys = {
        muid            : sys.muid || '',
        device_id       : sys.device_id || '',
        app_version     : appVersion,
        app_info        : sys.app_info || '',
        is_jailbroken_phone: sys.is_jailbroken_phone || false,//是否越狱手机
        package_id      : sys.package_id || '',
        //新协议:handshake/get_network里获取
        wifi            : sys.wifi || false,
        //新协议:get_freecard里获取
        kkflowtype      : sys.kkflowtype || false,
        gender          : sys.gender || '',
        manufacturer    : sys.manufacturer || '', //厂商
        model           : sys.model || '', //型号
        screen_height   : sys.screen_height || 0, //屏幕高
        screen_width    : sys.screen_width || 0, //屏幕宽
        abtest_sign     : sys.abtest_sign || [], //
        os_version      : sys.os_version || '', //系统版本

    }
}
const setUser = (user) => {
    window.__gvalkkmh.user = {
        id      : user.uid || 0,
        session : user.session || '',
    }
}

const popLogin = () => {
    return new Promise(resolve => {
        if (window.current_login_mode == LOGIN_MUST) {
            doLogout().then(() => {
                window.__gvalkkmh.is_called_loginwindow = true;
                doLogin().then((is_logined) => {
                    resolve(is_logined);
                });
            });
        }
        if (window.current_login_mode == LOGIN_NEED && !window.__gvalkkmh.user.id) {
            window.__gvalkkmh.is_called_loginwindow = true;
            doLogin().then((is_logined) => {
                resolve(is_logined);
            });
        } 
        if (window.current_login_mode == LOGIN_NEED && window.__gvalkkmh.user.id) {
            resolve(false);    
        }
    });
}

const doLogout = () => {
    return new Promise(resolve => {
        if (IS_POPLOGIN_VER) {
            request('logout_new').then(() => {
                resolve();
            });
        } else {
            request('logout').then(() => {
                resolve();
            });
        }
        window.__gvalkkmh.user = {};
    });
}
const doLogin = () => {
    return new Promise(resolve => {
        if (IS_POPLOGIN_VER) {
            request('login').then((res) => {
                let is_logined = getDeepVal(res, 'data.is_success_login', 0)==1 || false;
                coverWkwebviewError(resolve,is_logined);// 修复wk问题
            });
        } else {
            request('login_win').then((res) => {
                let is_logined = getDeepVal(res, 'data.status', 0)==1 || false;
                coverWkwebviewError(resolve,is_logined);// 修复wk问题
            });
        }
    });
}
/*
 * 解决版本：ios wk-5.72
 * 问题描述wkwebview下 早期版本存在问题。（登录框未消失前调用接口偶现异常发送错误，采用监听H5可见后在往后执行）
 * 弃用原因，监听在未登录关闭时比login前执行，登录成功关闭时login后执行。（太费劲儿啦怎么判断这次是提前执行的还是后执行的）
 * 改用延时解决吧。
*/
const coverWkwebviewError = (resolve,is_logined) => {
    if (is_logined) {
        docoverWkwebviewError().then(() => {
            resolve(is_logined);
        });
    } else {
        resolve(is_logined);
    }
}
const docoverWkwebviewError = () => {
    return new Promise(resolve => {
        if (IS_WKUSEAJAX_LOWVER) {
            setTimeout(() => {
                console.log('sleep30');
                resolve();
            },30);
        } else {
            resolve();
        }
    })
}
/**
 * * h5init : 初始化h5 [ua, qs, hybrid(sysinfo/logininfo/fullscreen/whitearea/ ...)]
 * 参数
 * options={
 *    @login_mode   : 'unwanted',       //string : unwanted[default], need, must           
 * }
 *
 * 返回:无
 * **/
const verifyLoginMode = (login_mode) => {
    if (login_mode !== LOGIN_UNWANTED && login_mode !== LOGIN_NEED && login_mode !== LOGIN_MUST) {
        window.current_login_mode = LOGIN_UNWANTED;
    } else {
        window.current_login_mode = login_mode;
    }
}

const h5init = ({login_mode=''} = {}) => {
    window.w_t1 = new Date().getTime();
    verifyLoginMode(login_mode);
    return new Promise(resolve => {
        switch(window.current_login_mode) {
            case LOGIN_UNWANTED:
                sysinfo().then(() => {
                    h5initAfter(resolve);
                });
            break;
            case LOGIN_NEED:
                sysinfo().then(() => {
                    h5initPoplogin(resolve);
                });
            break;
            case LOGIN_MUST:
                h5initPoplogin(resolve);
            break;
        }
    });
}
const h5initPoplogin = (resolve) => {
    popLogin().then((respopLogin) => {
        if (respopLogin) {
            sysinfo('update_user').then(() => {
                h5initAfter(resolve);
            });
        } else {
            h5initAfter(resolve);
        }
    });
}
const h5initAfter = (resolve) => {
    setTrack();
    setUserSession();
    setIosWhiteArea();
    setFullScreen();
    is_first_init = true; //初始化标记
    resolve(window.__gvalkkmh);

    // 日志输出
    window.w_t2 = new Date().getTime();
    loging(`【h5init(${window.current_login_mode}模式)-数据返回】`,window.__gvalkkmh);
    loging(`【h5init(${window.current_login_mode}模式)-协议记录】`,request_record);
    loging(`【h5init(${window.current_login_mode}模式)-总耗时:】${w_t2-w_t1}ms]`);
    setTimeout(() => {
        request_record = {};
        count_num = 0;
    },1000)
}

export default h5init








// WEBPACK FOOTER //
// ./node_modules/@kkmh/h5init/src/h5init.js